const columns = [
  {
    name: 'Enterprise',
    selector: (row) => row.attributes.company,
    sortable: true,
  },
  {
    name: 'Date',
    selector: (row) => row.attributes.added_date,
    sortable: true,
  },
  {
    name: 'Contact',
    selector: (row) => row.attributes.contact,
    sortable: true,
  },
  {
    name: 'Email',
    selector: (row) => row.attributes.email,
    sortable: true,
  },
  {
    name: 'Website',
    selector: (row) => row.attributes.website,
    sortable: true,
  },

];

export default columns;
